import { mediaItems } from '@/mocks/cinema';

export default function SectionMedia() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            精彩预告
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            热播剧集抢先看，精彩瞬间不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/30 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full bg-primary-500/80 flex items-center justify-center transition-transform duration-200 group-hover:scale-110">
                    <i className="ri-play-fill text-2xl text-background-950 ml-1" />
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500/80 text-background-950 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-heading text-foreground-100 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}